/** Fixed navbar offset (px) for scroll-into-view */
export const NAV_SCROLL_OFFSET = 88;

/**
 * Smoothly scroll to an element by id, accounting for fixed header.
 */
export function scrollToElementById(id, behavior = 'smooth') {
  if (!id) {
    window.scrollTo({ top: 0, behavior });
    return;
  }

  const el = document.getElementById(id);
  if (!el) {
    window.scrollTo({ top: 0, behavior });
    return;
  }

  const top = el.getBoundingClientRect().top + window.scrollY - NAV_SCROLL_OFFSET;
  window.scrollTo({ top: Math.max(0, top), behavior });
}

/**
 * Scroll to top of the page.
 */
export function scrollToTop(behavior = 'smooth') {
  window.scrollTo({ top: 0, behavior });
}

/**
 * Parse "/path#hash" into { pathname, hash }.
 */
export function parseNavHref(href) {
  const [pathname = '/', hash = ''] = href.split('#');
  return { pathname: pathname || '/', hash };
}
